/* Polita — Cookie consent + Consent Mode (Shopify Customer Privacy API)
   Nessuno script non essenziale (GA4, Meta Pixel, mappe) viene caricato
   prima del consenso esplicito. Rifiuto facile quanto l'accettazione. */
(function () {
  'use strict';

  var STORAGE_KEY = 'polita_cookie_consent_v1';
  var root = document.getElementById('cookie-consent');

  var cfg = {
    ga4: root ? root.getAttribute('data-ga4') : null,
    pixel: root ? root.getAttribute('data-pixel') : null
  };

  /* ---------- Storage ---------- */
  function readDecision() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }
  function saveDecision(d) {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(d)); } catch (e) {}
  }

  /* ---------- Shopify Consent Mode ---------- */
  function setShopifyConsent(d) {
    var consent = {
      analytics: !!d.analytics,
      marketing: !!d.marketing,
      preferences: !!d.preferences,
      sale_of_data: !!d.marketing
    };
    function apply() {
      try {
        if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
          Shopify.customerPrivacy.setTrackingConsent(consent, function () {});
        }
      } catch (e) {}
    }
    try {
      if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
        apply();
      } else if (window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { apply(); });
      }
    } catch (e) {}
  }

  /* ---------- Loader script non essenziali ---------- */
  function loadGA4(id) {
    if (!id || window.__politaGA4) return;
    window.__politaGA4 = true;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id);
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', id, { anonymize_ip: true });
  }

  function loadPixel(id) {
    if (!id || window.__politaPixel) return;
    window.__politaPixel = true;
    /* eslint-disable */
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', id);
    window.fbq('track', 'PageView');
  }

  /* ---------- Mappe click-to-load ---------- */
  function loadMap(container) {
    if (!container || container.getAttribute('data-loaded') === 'true') return;
    var tpl = container.querySelector('[data-map-html]');
    if (!tpl) return;
    container.setAttribute('data-loaded', 'true');
    var ph = container.querySelector('[data-map-placeholder]');
    if (ph) ph.remove();
    var holder = document.createElement('div');
    holder.className = 'contact__map-frame';
    holder.innerHTML = tpl.innerHTML;
    container.appendChild(holder);
  }

  function syncMaps(d) {
    var maps = document.querySelectorAll('[data-consent-map]');
    for (var i = 0; i < maps.length; i++) {
      if (d && d.preferences) loadMap(maps[i]);
    }
  }

  /* ---------- Applica consenso ---------- */
  function applyConsent(d) {
    setShopifyConsent(d);
    if (d.analytics) loadGA4(cfg.ga4);
    if (d.marketing) loadPixel(cfg.pixel);
    syncMaps(d);
    document.dispatchEvent(new CustomEvent('polita:consent', { detail: d }));
  }

  /* ---------- UI ---------- */
  if (!root) {
    // Nessun banner: la mappa resta click-to-load manuale.
    bindManualMaps();
    return;
  }

  var banner = root.querySelector('[data-cc-banner]');
  var overlay = root.querySelector('[data-cc-overlay]');
  var panel = root.querySelector('[data-cc-panel]');
  var lastFocus = null;

  function showBanner() {
    if (!banner) return;
    banner.hidden = false;
  }
  function hideBanner() {
    if (banner) banner.hidden = true;
  }
  function openPanel() {
    if (!overlay) return;
    var d = readDecision() || { analytics: false, marketing: false, preferences: false };
    setToggle('analytics', d.analytics);
    setToggle('marketing', d.marketing);
    setToggle('preferences', d.preferences);
    lastFocus = document.activeElement;
    overlay.hidden = false;
    var first = panel.querySelector('input, button');
    if (first) first.focus();
    document.addEventListener('keydown', onKeydown);
  }
  function closePanel() {
    if (!overlay) return;
    overlay.hidden = true;
    document.removeEventListener('keydown', onKeydown);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKeydown(e) {
    if (e.key === 'Escape') { closePanel(); return; }
    if (e.key === 'Tab') trapFocus(e);
  }
  function trapFocus(e) {
    var f = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function setToggle(cat, val) {
    var el = root.querySelector('[data-cc-cat="' + cat + '"]');
    if (el) el.checked = !!val;
  }
  function getToggle(cat) {
    var el = root.querySelector('[data-cc-cat="' + cat + '"]');
    return el ? el.checked : false;
  }

  function decide(d) {
    saveDecision(d);
    applyConsent(d);
    hideBanner();
    closePanel();
  }

  function bind(sel, fn) {
    var els = root.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) els[i].addEventListener('click', fn);
  }

  bind('[data-cc-accept]', function () {
    decide({ analytics: true, marketing: true, preferences: true, ts: Date.now() });
  });
  bind('[data-cc-reject]', function () {
    decide({ analytics: false, marketing: false, preferences: false, ts: Date.now() });
  });
  bind('[data-cc-prefs-open]', function () { openPanel(); });
  bind('[data-cc-prefs-close]', function () { closePanel(); });
  bind('[data-cc-save]', function () {
    decide({
      analytics: getToggle('analytics'),
      marketing: getToggle('marketing'),
      preferences: getToggle('preferences'),
      ts: Date.now()
    });
  });
  if (overlay) overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePanel();
  });

  // Riapertura preferenze da qualunque elemento [data-cookie-prefs] (es. footer)
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-cookie-prefs]');
    if (t) { e.preventDefault(); openPanel(); }
  });

  // Caricamento manuale mappa (anche senza consenso preferenze: azione esplicita)
  bindManualMaps();

  function bindManualMaps() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-map-load]');
      if (!btn) return;
      e.preventDefault();
      var container = btn.closest('[data-consent-map]');
      loadMap(container);
    });
  }

  /* ---------- Avvio ---------- */
  var decision = readDecision();
  if (decision) {
    applyConsent(decision);
  } else {
    showBanner();
  }
})();
